import { render, staticRenderFns } from "./lrCardList.vue?vue&type=template&id=50a5af1c"
import script from "./lrCardList.vue?vue&type=script&lang=js"
export * from "./lrCardList.vue?vue&type=script&lang=js"
import style0 from "./lrCardList.vue?vue&type=style&index=0&id=50a5af1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports